import React from "react";

export default function Buy() {
  return (
    <div className="buy">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>How to Buy</h1>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-2">
                <img
                  src="./Asserts/arrow.png"
                  className="img-fluid arrow"
                  alt=""
                />
              </div>
              <div className="col-10">
                <h2>Create MetaMask Wallet</h2>
                <p>
                  create a metamask wallet using either a desktop computer or an
                  ios/android mobile device.
                </p>
              </div>
            </div>

            <div className="row pt-4">
              <div className="col-2">
                <img
                  src="./Asserts/arrow.png"
                  className="img-fluid arrow"
                  alt=""
                />
              </div>
              <div className="col-10">
                <h2>Send ETH to Your Wallet</h2>
                <p>
                  you can buy ethereum (eth) directly on metamask or transfer it
                  to your metamask wallet from exchanges like bitmart, ethereum,
                  etc.
                </p>
              </div>
            </div>

            <div className="row pt-4">
              <div className="col-2">
                <img
                  src="./Asserts/arrow.png"
                  className="img-fluid arrow"
                  alt=""
                />
              </div>
              <div className="col-10">
                <h2>Connect Your Wallet to Uniswap</h2>
                <p>
                  connect your wallet to uniswap by clicking ‘connect wallet’
                  and selecting metamask.
                </p>
              </div>
            </div>

            <div className="row pt-4">
              <div className="col-2">
                <img
                  src="./Asserts/arrow.png"
                  className="img-fluid arrow"
                  alt=""
                />
              </div>
              <div className="col-10">
                <h2>Swap ETH for Takashinu </h2>
                <p>
                  you can start swapping as soon as you have eth available!
                  press "select a token" and enter the token address or search
                  for it on the tokens list.
                </p>
              </div>
            </div>
          </div>
          <div className="col-1"></div>
          <div className="col-lg-5 ">
            <div className="embeded-page">
              <iframe
                src="https://app.uniswap.org/#/swap?outputCurrency=0x5f20f15d40f24dae50a72be3b5edddddfb5a5bd0&amp;chain=mainnet&amp;inputCurrency=ETH"
                height="560px"
                width="100%"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
